export default __webpack_public_path__ + "static/media/OpenSans-Bold.17c35116.woff";